var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "confirmcontainer"
    }
  }, [_c('sweet-modal', {
    ref: _vm.uuid,
    attrs: {
      "icon": _vm.icon,
      "overlay-theme": "white",
      "title": _vm.title
    }
  }, [_c('div', {
    staticClass: "slot-content"
  }, [_c('div', {
    staticClass: "alertmessage",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    staticStyle: {
      "background-color": "white",
      "border-top": "none",
      "text-align": "right"
    },
    slot: "button"
  }, [(_vm.Ncallback) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close('n')
      }
    }
  }, [_vm._v(_vm._s(_vm.NtxtBtn))]) : _vm._e(), _vm._v(" "), (_vm.Ycallback) ? _c('button', {
    staticClass: "btn btn-primary-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close('y')
      }
    }
  }, [_vm._v(_vm._s(_vm.YtxtBtn))]) : _vm._e()])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-764f0856","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/modalWrapper/Confirm.vue
// module id = 1539
// module chunks = 1